import './index.less';
import classNames from 'classnames';
import React, { memo, useMemo } from 'react';
import BonusItem from '../BonusItem/BonusItem';
import ActivityItem from './ActivityItem/ActivityItem';
import { useActivityEntryPlus } from '@/store/home';
import useDialogManager from '@/utils/useDialogManager';
import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus';
import { useLocation } from 'react-router';
import { useMobileLeftSiderSwitch } from '@/store/commonStore';
import { useBeforeSetting } from "@/store/beforeSetting";

const Activity = (props) => {
  const { className, collapsed } = props;
  const prefixCls = 'activity';
  const { t } = useTranslationPlus('BonusView');
  const { data } = useActivityEntryPlus();
  const { farm, rebate, turntable, luckyMoney } = data || {};
  const { openDialogInviteWheel, openBetting, openFarm,  openSharePage, openTaskCenter, openWheel, openRainPack } = useDialogManager();
  const { pathname } = useLocation();
  const [drawerVisible, setDrawerVisible] = useMobileLeftSiderSwitch();
  const { data: sitting } = useBeforeSetting()

  const fullLastItem = useMemo(() => {
    let length = 1;
    if (data?.turntable?.isOpen) {
      length += 1;
    }
    if (data?.farm?.isOpen) {
      length += 1;
    } if (data?.rebate?.isOpen) {
      length += 1;
    }
    if (data?.luckyMoney?.isOpen) {
      length += 1;
    }
    if(data?.inviteTurnTable?.isOpen) {
      length += 1;
    }

    return length % 2 !== 0
  }, [data])

  const activityItems = useMemo(() => {
    const ret = []
    if (data) {
      ret.push({
        icon: <img src={require(`@/assets/image/bonus/jlzx_icon_rw.webp`)} />,
        title: t('TaskCenter'),
        className: 'activity-item task',
        onclick: () => {
          setDrawerVisible(false);
          openTaskCenter();
        }
      })

      if (data?.turntable?.isOpen) {
        ret.push({
          icon: <div className="image-span"></div>,
          title: t('LuckySpin'),
          className: 'activity-item turntable',
          onclick: () => {
            openWheel();
            setDrawerVisible(false);
          }
        })
      }

      if (data?.farm?.isOpen) {
        ret.push({
          icon: <img src={require(`@/assets/image/bonus/jlzx_icon_tree.webp`)} />,
          title: t('MoneyFarm'),
          className: 'activity-item farm',
          onclick: () => {
            openFarm();
            setDrawerVisible(false);
          }
        })
      }

      if (data?.rebate?.isOpen) {
        ret.push({
          icon: <img src={require(`@/assets/image/home/pig_icon.webp`)} />,
          title: t('RebateBet'),
          className: 'activity-item rebate',
          onclick: () => {
            openBetting();
            setDrawerVisible(false);
          }
        })
      }


      if (data?.luckyMoney?.isOpen) {
        ret.push({
          icon: <img src={require(`@/assets/image/bonus/qiutubiao.png`)} />,
          title: t('Redpack'),
          className: 'activity-item luckyMoney',
          onclick: () => {
            openRainPack();
            setDrawerVisible(false);
          }
        })
      }
    }

    if(data?.inviteTurnTable?.isOpen) {
      ret.push({
        icon: <div className="image-span"></div>,
        title: t('ShareSpin'),
        className: 'activity-item shareSpin',
        onclick: () => {
          openDialogInviteWheel();
          setDrawerVisible(false);
        }
      })
    }
    return ret;
  }, [data])

  return (
    <div className={classNames([`${prefixCls}`, className])}>
      <BonusItem className={`${prefixCls}-bonus`} isSelect={pathname === '/bonus'} />
      <div className={`${prefixCls}-items`}>


        {activityItems.map((v, index) => {
          return <ActivityItem
            style={{ minWidth: index === activityItems.length - 1 && fullLastItem ? '100%' : 'calc(50% - 5px)' }}
            key={index}
            collapsed={collapsed}
            icon={v.icon}
            title={v.title}
            className={v.className}
            onClick={v.onclick}
          />
        })}
      </div>

      <ActivityItem
          collapsed={collapsed}
          icon={
            collapsed ?  <img src={collapsed ? require(`@/assets/image/home/iconjinbi_samll.png`) : require(`@/assets/image/home/iconjinbi.png`) } /> :
                <div className='image-span'></div>
          }
          title={t('Invite')}
          className={`invate-friends ${collapsed ? 'invate-friends-collapsed' : ''}`}
          onClick={() => {
            openSharePage();
            setDrawerVisible(false);
          }}
      />
    </div>
  );
};
export default memo(Activity);
